import React, { useState } from 'react'
import styled, { css, RuleSet } from 'styled-components'
import { ActiveArrowIcons } from 'src/components/common/ActiveArrowIcon'
import useOutsideClickDetector from 'src/hooks/useOutsideClickDetector.hook'
import RenderIf from 'src/components/common/RenderIf'

export type listItemsType<T> = { text: string; value: T }

export interface CustomSelectProps<T> {
  listItems: listItemsType<T>[]
  customSelectWrapStyle?: RuleSet<object>
  defaultSelectWrapStyle?: RuleSet<object>
  activeSelectWrapStyle?: RuleSet<object>
  openSelectWrapStyle?: RuleSet<object>
  openSelectItemsStyle?: RuleSet<object>
  selectOnchangeHandler: (value: T) => void
  currentValue: number
}

const CustomSelect = <T,>({
  customSelectWrapStyle,
  defaultSelectWrapStyle,
  openSelectWrapStyle,
  activeSelectWrapStyle,
  listItems,
  selectOnchangeHandler,
  currentValue,
  openSelectItemsStyle,
}: CustomSelectProps<T>) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleDropdown = () => {
    setIsOpen(!isOpen)
  }
  const selectHandler = (value: T) => {
    setIsOpen(!isOpen)
    selectOnchangeHandler(value)
  }

  const { outside_ref } = useOutsideClickDetector(isOpen, toggleDropdown)
  const textOfCurrentValue = listItems?.find((w) => w.value === currentValue)?.text

  return (
    <CustomSelectWrap $customSelectWrapStyle={customSelectWrapStyle} ref={outside_ref}>
      <ClosedSelect
        $defaultSelectWrapStyle={defaultSelectWrapStyle}
        $activeSelectWrapStyle={isOpen ? activeSelectWrapStyle : css``}
        onClick={toggleDropdown}
      >
        {textOfCurrentValue as string}
        <ActiveArrowIcons $active={isOpen} $color="var(--black-30)" />
      </ClosedSelect>
      <OpenSelect $isOpen={isOpen} $openSelectWrapStyle={openSelectWrapStyle}>
        {listItems.map(({ value, text }: listItemsType<T>) => (
          <RenderIf when={currentValue !== value} key={text}>
            <SelectItems
              onClick={() => selectHandler(value)}
              $openSelectItemsStyle={openSelectItemsStyle}
            >
              {text}
            </SelectItems>
          </RenderIf>
        ))}
      </OpenSelect>
    </CustomSelectWrap>
  )
}

export default CustomSelect

const CustomSelectWrap = styled.div<{ $customSelectWrapStyle?: RuleSet<object> }>`
  position: relative;
  ${(props) => props.$customSelectWrapStyle};
`

const ClosedSelect = styled.button<{
  $defaultSelectWrapStyle?: RuleSet<object>
  $activeSelectWrapStyle?: RuleSet<object>
}>`
  ${(props) => props.$defaultSelectWrapStyle};
  ${(props) => props.$activeSelectWrapStyle};
`

const OpenSelect = styled.ul<{ $isOpen: boolean; $openSelectWrapStyle?: RuleSet<object> }>`
  list-style-type: none;
  display: ${(props) => (props.$isOpen ? 'block' : 'none')};
  position: absolute;
  width: 100%;
  ${(props) => props.$openSelectWrapStyle};
`

const SelectItems = styled.li<{ $openSelectItemsStyle?: RuleSet<object> }>`
  width: 100%;
  cursor: pointer;
  ${(props) => props.$openSelectItemsStyle};
`
